import { Pipe, PipeTransform } from '@angular/core';

/** Truncates text to a max line count and a max character count, appending a suffix when cut. */
@Pipe({
  name: 'lineClampText',
  pure: true,
})
export class LineClampTextPipe implements PipeTransform {
  transform(
    value: string | null | undefined,
    maxLines = 6,
    maxLength = 300,
    suffix = '...'
  ): string {
    if (!value) {
      return '';
    }

    const safeMaxLines = Number.isFinite(maxLines) && maxLines > 0 ? Math.floor(maxLines) : 6;
    const safeMaxLength = Number.isFinite(maxLength) && maxLength > 0 ? Math.floor(maxLength) : 300;

    let result = value.replace(/\r\n?/g, '\n');
    let truncated = false;

    const lines = result.split('\n');
    if (lines.length > safeMaxLines) {
      result = lines.slice(0, safeMaxLines).join('\n');
      truncated = true;
    }

    // Char cap applies regardless of how many newlines the text has.
    if (result.length > safeMaxLength) {
      result = result.slice(0, safeMaxLength);
      truncated = true;
    }

    return truncated ? result + suffix : result;
  }
}
